import serviceicon1 from "./assets/signal.png";
import serviceicon2 from "./assets/mobile.png";
import serviceicon3 from "./assets/mobile-game.png";
import serviceicon4 from "./assets/nanotech.png";
import serviceicon5 from "./assets/call.png";
import serviceicon6 from "./assets/assessment.png";
export const myServices = [
	{
		id: 1,
		title: "Telco VAS",
		description:
			"We specialize in value-added services and have expertise in integrating with leading aggregators and VAS providers, as well as creating innovative services.",
		icon: serviceicon1,
    details: {
      intro: "We design and manage high-performance subscription services across telecom channels.",
      features: [
        "SMS and USSD subscription services",
        "Premium short codes",
        "Interactive campaigns and promotions",
        "Digital content subscriptions",
      ],
      outro: "All services are built in strict alignment with regulatory requirements and network standards."
    },
		products: [
			{
				id: 1,
				title: "Music Trivia",
				description: "A fun trivia game focused on music knowledge.",
			},
			{
				id: 2,
				title: "Word Play",
				description: "A quiz that tests your knowledge of football history.",
			},
		],
	},
	{
		id: 2,
		title: "Direct Carrier Billing (DCB)",
		description:
			"We provide secure airtime-based billing infrastructure that allows subscribers to pay for apps, streaming services, gaming content, and digital subscriptions directly from their mobile accounts.",
		icon: serviceicon2,
		details: {
			intro:
				"Our DCB solutions include:",
			features: [
				"Integration with MNO billing systems",
				"Recurring and one-time subscription models",
				"Double Opt-In compliant onboarding",
				"Reporting and settlement reconciliation",

			],
			outro:
				"Carrier billing expands access to digital services while increasing operator revenue."
		},
	},
	{
		id: 3,
		title: "Digital Gaming Services",
		description:
			"Mobile entertainment is central to today’s connected generation. 247 Comcare develops and manages subscription-based and interactive gaming platforms designed for high engagement and recurring revenue within telecom networks. ",
		icon: serviceicon3,
    details: {
			intro:
				"Our gaming portfolio includes:",
			features: [
				"Trivia and competitive skill-based games",
				"Daily engagement formats",
				"Airtime-funded participation models",
				"Smartphone-optimized and feature-phone compatible services",

			],
			outro:
				"Our gaming infrastructure is built to integrate directly with network billing systems, enabling seamless monetization without external payment barriers."
		},
	},
	{
		id: 4,
		title: "Network Integration",
		description:
			"Our technical team ensures seamless integration within telecom ecosystems.",
		icon: serviceicon4,
      details: {
      intro:"Our network integration services include:",
      features: [
        "SMSC and USSD gateway connectivity",
        "Billing node integration",
        "CRBT platform deployment",
        "Secure-D compliance",
        "Real-time monitoring and analytics"
      ],
      outro:"We build solutions that operate reliably within existing network infrastructure."
    }
	},
	{
		id: 5,
		title: "Caller Ring Back Tone (CRBT) Services",
		description:
			"We deploy and manage CRBT platforms that allow subscribers to personalize their outbound calls with licensed music and branded audio content.",
		icon: serviceicon5,
    details: {
      intro: "Our CRBT capabilities include:",
      features: [
        "Music licensing and content integration",
        "Subscription lifecycle management",
        "Promotional campaigns and artist partnerships",
        "Revenue tracking and reporting",

      ],
      outro: "CRBT remains a culturally relevant and high-performing telecom service across African markets."
    }
	},
	{
		id: 6,
		title: "Compliance & Governance",
		description:
			"Compliance is foundational to our operations. 247 Comcare operates in full alignment with telecommunications regulatory frameworks and consumer protection standards.",
		icon: serviceicon6,
    details: {
      intro: "Our governance structure includes:",
      features: [
        "Mandatory Double Opt-In processes",
        "Transparent billing notifications",
        "Anti-fraud protocols",
        "Content licensing compliance",
        "Structured complaint resolution procedures",
        "Internal monitoring and audit systems",
      ],
      outro: "We prioritize subscriber trust, regulatory integrity, and long-term sustainability."
    }
	},
];

export const productDetails = {
	"music-trivia": {
		title: "Music Trivia",
		about: `
        <p>MUSIC TRIVIA is an engaging and informative game designed to test players' knowledge across a wide array of music genres, artists, and significant historical moments. It's crafted to appeal to a diverse audience by offering questions on everything from lyrics and album names to musical history and biographies of artists. This game blends fun with education, encouraging participation through competitive elements such as scoring systems and rewards. It serves as an entertaining method for music lovers to gauge their understanding, while also fostering the exploration of new tunes and enhancing the recognition of the music industry's cultural impact. Upon subscribing or renewing their subscription, players receive 10 points, making them eligible for the daily draw, with 10 points being the threshold for entry. Daily questions are provided for users to answer, with opportunities to engage further. For each correct answer, participants earn 10 points, increasing their likelihood of winning with each point accrued.</p>
      `,
		howToPlay: `
        <p>To play, users just need to subscribe by sending an SMS keyword to a short code. Standard double-opt-in rule applies. After being charged successfully, the subscriber receives welcome SMS from MTN and contents(2 questions) from the shortcode. For subscribing to the service, the subscriber gets 10 points, and 10 points for every correct question. Subscription is charged at a daily fee of N100, N200 for 7 days, N500 for 30 days, and N50 on-demand fee. Users can choose to play more than once in a day to stand better chances. Subscribers will be able to play on-demand up to a maximum of 10 times in a day, after which they are not allowed to play again until the next day. The minimum point to qualify for a draw is 10 points, that is a subscriber qualifies for the daily draw on subscription and renewal but stands a better chance of winning by getting more points by answering the questions correctly. There will be daily and monthly draws.
</p>
        <table>
          <thead>
            <tr>
              <th>Plan Name</th>
              <th>Subscription Keywords</th>
              <th>Unsubscription Keywords</th>
              <th>Short Code</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Music Trivia Daily</td>
              <td>MUD</td>
              <td>STOP MUD</td>
              <td>20081</td>
              <td>100</td>
            </tr>
            <tr>
              <td>Music Trivia Weekly</td>
              <td>MUW</td>
              <td>STOP MUW</td>
              <td>20081</td>
              <td>200</td>
            </tr>
            <tr>
              <td>Music Trivia Monthly</td>
              <td>MUM</td>
              <td>STOP MUM</td>
              <td>20081</td>
              <td>500</td>
            </tr>
          </tbody>
        </table>
      `,
		termsAndConditions: `
        <p>These Terms and Conditions have been varied or amended as of 01 November 2024...</p>
        <ul>
          <li>Service will be available to all new and existing prepaid subscribers. </li>
          <li>Service will feature an auto-renewal, subscription, and On-demand.</li>
          <li>Subscribers will be required to opt-in to this service and be successfully billed as a pre-condition for winning in the draw.</li>
          <li>The process of opt-in will be simple and seamless. E.g. the customer text keyword to a short code, or dial a USSD string. Subscribers can also click a digital banner to subscribe.</li>
          <li>All entries qualify for the daily draws.</li>
          <li>Subscribers can play more than once to stand a better chance of winning.</li>
          <li>Subscribers who successfully subscribe to this service will be charged N100 daily, N200/ weekly and N500/ Monthly  for their subscription.</li>
          <li>Subscribers can opt out at any time of this service by texting a keyword, e.g.  MUD, MUW, MUM to 20081.</li>
          <li>For on-demand subscribers can text PLAY to 20081 to receive more questions and increase their points for every right answer.</li>
          <li>The broadcast of the opting-in, confirmation SMS, congratulatory SMS result, and the opting-out confirmation SMS from this service will be automated.</li>
          <li>Automated draws are done every day by 6pm. The monthly and Quarterly draws will be done on an announced date</li>
          <li>Winners must be active Subscribers of the MNO.</li>
          <li>Cash prizes are disbursed to the winners’ account number or via MoMo agents. Airtime prizes are automated.</li>
          <li>Cash winners are credited with an equal amount and will receive this notification: <strong> (Congratulations! You are a winner of Xx Xx.xx on wordplay. Please send your account details to 0XXXXXXXXXX to claim your prize.)</strong></li>
          <li>The Service begins immediately after the user subscribes.</li>
          <li>247 COMCARE reserves the right, at any time, to change these Terms and Conditions and any rules relating to its products and the Service, and to modify the Services at its discretion.</li>
          <li>247 COMCARE reserves the right from time to time to vary the charges of the Service as may be deemed necessary in its discretion.</li>
          <li>247 COMCARE shall be entitled to terminate the Service of any Customer, if such Customer is involved in any fraudulent activity or suspected fraudulent activity.</li>
        </ul>
      `,
	},
	"word-play": {
		title: "Word Play",
		about: `
          <p><strong>WORDPLAY Gaming service </strong> is a service where subscribers get to rearrange scattered english words in order to win cash and airtime. Customers get 10 points on subscription and renewal, thus qualifying for the daily draw. The minimum points to qualify for the daily draw is 10 points. Customers get two scattered words daily to rearrange and can play more. Customers get 10 points for every correct word they arrange correctly. The more the points, the more the chances of winning.</p>
        `,
		howToPlay: `
          <p>TTo play, users just need to subscribe by sending SMS keyword to a short code. Standard double-opt-in rule applies. After being charged successfully, the subscriber receives welcome SMS from MTN and contents(2 scattered words) from the shortcode. For subscribing to the service, the subscriber gets 10 points, and 10 points for every correct question. Subscription is charged at a daily fee of N100 ,N200 for 7 days, N500 for 30 days, and N50 on-demand fee. User can choose to play more than once in a day to stand better chances. Subscribers will be able to play the on-demand up to a maximum of 10 times in a day, after which they are not allowed to play again until the next day. The minimum point to qualify for a draw is 10 points, that is a subscriber qualifies for the daily draw on subscription and renewal but stands a better chance of winning by getting more points by answering the questions correctly. There will be daily and monthly draws.</p>
          <table>
            <thead>
              <tr>
                <th>Plan Name</th>
                <th>Subscription Keywords</th>
                <th>Unsubscription Keywords</th>
                <th>Short Code</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Wordplay Daily</td>
                <td>WOD</td>
                <td>STOP WOD</td>
                <td>20081</td>
                <td>100</td>
              </tr>
              <tr>
                <td>Wordplay Weekly</td>
                <td>WOW</td>
                <td>STOP WOW</td>
                <td>20081</td>
                <td>200</td>
              </tr>
              <tr>
                <td>Wordplay Monthly</td>
                <td>WOM</td>
                <td>STOP WOM</td>
                <td>20081</td>
                <td>500</td>
              </tr>
            </tbody>
          </table>
        `,
		termsAndConditions: `
          <p>These Terms and Conditions have been varied or amended as of 01 November 2024...</p>
          <ul>
            <li>Service will be available to all new and existing prepaid subscribers. </li>
            <li>Service will feature an auto-renewal, subscription, and On-demand.</li>
            <li>Subscribers will be required to opt-in to this service and be successfully billed as a pre-condition for winning in the draw.</li>
            <li>The process of opt-in will be simple and seamless. E.g. the customer text keyword to a short code, or dial a USSD string. Subscribers can also click a digital banner to subscribe.</li>
            <li>All entries qualify for the daily draws.</li>
            <li>Subscribers can play more than once to stand a better chance of winning.</li>
            <li>Subscribers who successfully subscribe to this service will be charged N100 daily, N200/ weekly and N500/ Monthly  for their subscription.</li>
            <li>Subscribers can opt out at any time of this service by texting a keyword, e.g.  WOD, WOW, WOM to 20081</li>
            <li>For on-demand subscribers can text MORE to 20081 to receive more questions and increase their points for every right answer.</li>
            <li>The broadcast of the opting-in, confirmation SMS, congratulatory SMS result, and the opting-out confirmation SMS from this service will be automated.</li>
            <li>Automated draws are done every day by 6pm. The monthly and Quarterly draws will be done on an announced date</li>
            <li>Winners must be active Subscribers of the MNO.</li>
            <li>Cash prizes are disbursed to the winners’ account number or via MoMo agents. Airtime prizes are automated.</li>
            <li>Cash winners are credited with an equal amount and will receive this notification: <strong> (Congratulations! You are a winner of Xx Xx.xx on wordplay. Please send your account details to 0XXXXXXXXXX to claim your prize.)</strong></li>
            <li>The Service begins immediately after the user subscribes.</li>
            <li>247 COMCARE reserves the right, at any time, to change these Terms and Conditions and any rules relating to its products and the Service, and to modify the Services at its discretion.</li>
            <li>247 COMCARE reserves the right from time to time to vary the charges of the Service as may be deemed necessary in its discretion.</li>
            <li>247 COMCARE shall be entitled to terminate the Service of any Customer, if such Customer is involved in any fraudulent activity or suspected fraudulent activity..</li>
          </ul>
        `,
	},
};
